import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import Tasks from 'APP/Tasks';
import {
  IEvent,
  IUpdateRecurrenceCalendarEventParams,
  CalendarModelErrorCode,
} from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export const updateRecurrenceCalendarEvent = async (
  params: IUpdateRecurrenceCalendarEventParams
): Promise<IEvent | null> => {
  try {
    const response = await calendarModel.updateRecurrenceCalendarEvent(params);

    popupsTasks.showToast(t('calendar_event_update_success'));

    return response;
  } catch (error) {
    if (error.message === CalendarModelErrorCode.Unauthorized) {
      Tasks.calendar.handleCalendarUnauthorized();
    }
    popupsTasks.showToast(t('something_went_wrong'));

    return null;
  }
};
